let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kR29d")).then(() => parcelRequire('6sWT1'));